import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { DEFAULT_LANGUAGE, loadLocalesDayJs } from 'i18n';

import { useGetUserCountry } from 'use-cases/get-user-country';

import { Amplitude } from 'services/analytics/amplitude';
import { GtagAnalytics } from 'services/analytics/gtag';

import { getPlans } from 'data/actions/subscriptions';
import { idSelector, userCountryCodeSelector } from 'data/selectors/user';

import { parseQuery } from 'utils/getQueryObject';
import { storeMarketingValues } from 'utils/storeMarketingValues';

import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

import { useGetUser } from './useGetUser';
import { useLoginByTokenQueryParam } from './useLoginByTokenQueryParam';

export const useIdentifyUser = () => {
  const dispatch = useDispatch();
  const countryCode = useSelector(userCountryCodeSelector);
  const userId = useSelector(idSelector);
  const { i18n } = useTranslation();
  const { getUser } = useGetUser();

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLoginByTokenQueryParam();

  useEffect(() => {
    const hasClickId = window.location.search.includes('clickid=');
    if (!localStorage.getItem(LOCAL_STORAGE_KEYS.IS_ORGANIC_USER)) {
      localStorage.setItem(LOCAL_STORAGE_KEYS.IS_ORGANIC_USER, hasClickId ? 'false' : 'true');
    }
  }, []);

  useGetUserCountry();

  useEffect(() => {
    if (countryCode)
      dispatch(
        getPlans({
          userCountry: countryCode
        })
      );
  }, [countryCode, dispatch]);

  useEffect(() => {
    Amplitude.init();
    GtagAnalytics.init();
    storeMarketingValues();
    loadLocalesDayJs();
  }, []);

  useEffect(() => {
    Amplitude.updateUser({
      key: 'language',
      value: i18n.language || DEFAULT_LANGUAGE,
      ...parseQuery(window.location.href)
    });
  }, [i18n?.language, userId]);
};
